import axios from '@/libs/axios'

export default {
  getTeamDefinition: id => axios.get(`/team/definition/${id}`),
  getTeamDefinitions: query => axios.get('/team/definition', { params: query }),
  getFreeTeamDefinitions: () => axios.get('/team/definition/find?freeOnly'),
  addTeamDefinition: data => axios.post('/team/definition', data),
  updateTeamDefinition: (id, data) => axios.put(`/team/definition/${id}`, data),
}
